import type { PropertyValueResource } from "@octopusdeploy/octopus-server-client";
import { isSensitiveValue } from "@octopusdeploy/octopus-server-client";
import { ObfuscatedPlaceholder } from "~/components/form/Sensitive/Sensitive";
export function stringifyActionProperty(propertyValue: PropertyValueResource) {
    return isSensitiveValue(propertyValue) ? ObfuscatedPlaceholder : propertyValue;
}
